var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"footer-box"},[_c('ul',[_c('li',[_c('div',[_vm._v("Copyright © 2023 COTTON GAME. 保留所有权利")])]),_c('li',[_c('div',[_vm._v("健康游戏忠告：抵制不良游戏 拒绝盗版游戏 注意自我保护 谨防受骗上当")])]),_c('li',[_c('div',[_vm._v("   适度游戏益脑 沉迷游戏伤身 合理安排时间 享受健康生活")])])])])
}]

export { render, staticRenderFns }